
import { DefaultStyle, SamplesStyle } from "./features/map"
import { getRoundedMoneyValue } from "./shared/fieldsHelper";
import { Style, Stroke, Fill } from 'ol/style';
import Hash from './shared/Hash';


const styleForProps = {
    maxWidth: "90%",
    whiteSpace: "break-spaces",
    fontSize: "18px",
    margin: "20px 0"
}

export const Config = {

    path: "/product/oks3782/",

    metricModuleId: "oks3782",

    texts: {
        appName: "Робот 378.2",
        title: ['Налоговые резервы', 'для торгово-офисной недвижимости'],
        subtitle: ['— программный продукт для анализа налоговых начислений на торгово-офисную недвижимость по ст. 378.2 НК РФ. Автоматически выявляет объекты, соответствующие критериям для применения 2% налоговой ставки'],
        textInfos: [
            {
                upper: '',
                title: 'Автоматическое выявление налоговых резервов',
                text: [
                    'Анализирует все ОКС и ЗУ по всей России и находит ошибки в налогообложении торгово-офисной недвижимости.',
                    'Напрямую влияет на доход региона, который исчисляется сотнями миллионов рублей:',
                    '— показывает, сколько бюджетных средств можно получить за счёт исправления ошибок',
                    '— помогает муниципалитетам увеличить сборы, а бизнесу — оцифровать риски по налоговой нагрузке'
                ]
            },
            {
                upper: '',
                title: 'Интеллектуальная категоризация',
                text: [
                    'Распределяет объекты на 7 категорий (от подтверждённых коммерческих до потенциальных) для точного анализа.',
                    'Выявляет в том числе:',
                    '✓ незарегистрированные постройки',
                    '✓ жилые здания с коммерческим потенциалом',
                    '✓ ошибочно включённые в реестр объекты'
                ]
            },
            {
                upper: '',
                title: 'Работает на основе данных ЕГРН и ГКО',
                text: [
                    '— использует официальные источники (Росреестр, кадастровые данные)',
                    '— минимизирует риски — только легальные способы расчёта налогов'
                ]
            }
        ],
        algorithmTextInfos: [
            {
                upper: '',
                title: '',
                text: [
                    'Наш сервис анализирует коммерческую недвижимость и автоматически распределяет все объекты на 7 категорий для оптимального исправления налоговых начислений:',
                    '1. Подтверждённые торговые объекты: здания и помещения, официально зарегистрированные как коммерческие в ЕГРН',
                    '2. Потенциально коммерческие объекты: объекты, которые могут относиться к торговой недвижимости по дополнительным данным',
                    '3. Объекты с коммерческим назначением: недвижимость, предназначенная для бизнеса согласно документам',
                    '4. Фактически используемые для бизнеса: помещения, реально занятые под магазины, офисы и другие коммерческие цели',
                    '5. Незарегистрированные постройки: строения, которые можно официально оформить и включить в реестр',
                    '6. Жилая недвижимость с коммерческим потенциалом: жилые здания, которые можно перевести в нежилой фонд',
                    '7. Объекты для проверки: помещения, которые возможно ошибочно включены в коммерческий реестр',
                    'Простыми словами: мы находим все здания и помещения, которые уже являются торговыми или могут быть переведены в коммерческую категорию,',
                    'и это помогает определить объекты, подлежащие легальному налогообложению в 2%.'
                ]
            }
        ],
        footer: {
            docToFetch: "https://rk.geosamara.ru/product/oks3782/russiaStats.json",
            text: ['', '']
        },
        report: {
            button: "Отчет",
            header: "Отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Мы с вами свяжемся!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_231/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 1) ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_231/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 2) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_231/{z}/{x}/{y}.pbf",
            maxZoom: 12,
            style: (p) => {
                return (p.properties_.level === 3) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_232/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                const category = p.properties_?.origin?.split(".").at(-1) || null;

                if (category === "1") return SamplesStyle;

                if (category === "2") return new Style({
                    stroke: new Stroke({
                        color: "#FF6A00",
                        width: 1
                    }),
                    fill: new Fill({
                        color: "#FF6A00",
                    }),
                });

                if (category === "3") return new Style({
                    stroke: new Stroke({
                        color: "#F8D617",
                        width: 1
                    }),
                    fill: new Fill({
                        color: "#F8D617",
                    }),
                });

                if (category === "4") return new Style({
                    stroke: new Stroke({
                        color: "#BFBC18",
                        width: 1
                    }),
                    fill: new Fill({
                        color: "#BFBC18",
                    }),
                });

                return new Style({});
            },
            turned: false,
            afterTurned: (view) => {
                // view.setCenter([6135702.16836477, 6759726.488507118]) //Оренбург
                view.setCenter([5587958, 7016790]); //Самара
                // view.setCenter([5481772, 7518731]); //Казань
                view.setZoom(12.7);
            }
        }
    ],
    featureInfo: {
        properties: [
            { name: 'Муниципалитет', field: (p) => p.municipalitet, style: { fontSize: '22px' } },
            { name: 'Регион', field: (p) => p.region, style: { fontSize: '22px' } },
            {
                name: "Количество новых ОКС и помещений для реестра",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type21extraCount + p.type21roomsCount + p.type22extraCount + p.type22roomsCount + p.type23extraCount + p.type23roomsCount + p.type24extraCount + p.type24roomsCount;
                },
                unit: "шт"
            },

            {
                name: "Дополнительный налог",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxHighProbability + 0.1 * p.extraTaxLowProbability + p.roomsExtraTaxHighProbability + 0.1 * p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxHighProbability + 0.1 * p.extraTaxLowProbability + p.roomsExtraTaxHighProbability + 0.1 * p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                }
            },

            {
                name: "Прогноз по эффекту в первый год",
                field: (p) => {
                    let fullExtraTax = {
                        v: 0.3 * p.extraTaxHighProbability + 0.1 * p.extraTaxLowProbability + 0.3 * p.roomsExtraTaxHighProbability + 0.1 * p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: 0.3 * p.extraTaxHighProbability + 0.1 * p.extraTaxLowProbability + 0.3 * p.roomsExtraTaxHighProbability + 0.1 * p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                }
            },


            {
                name: "ОКС не в реестре (высокая вероятность)",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxHighProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxHighProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                },
                style: { fontSize: '40px', lineHeight: '40px', color: '#D10015' }
            },

            {
                name: "ОКС не в реестре (низкая вероятность)",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.extraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                },
                style: { fontSize: '40px', lineHeight: '40px', color: '#6b6162' }
            },

            {
                name: "Помещения не в реестре (высокая вероятность)",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.roomsExtraTaxHighProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.roomsExtraTaxHighProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                },
                style: { fontSize: '40px', lineHeight: '40px', color: '#D10015' }
            },

            {
                name: "Помещения не в реестре (низкая вероятность)",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.roomsExtraTaxLowProbability
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                },
                style: { fontSize: '40px', lineHeight: '40px', color: '#6b6162' }
            },


            /*
            {
                name: "Дополнительный налог",
                field: (p) => {
                    let fullExtraTax = {
                        v: p.type21extraTax + p.type21roomsExtraTax + p.type22extraTax + p.type22roomsExtraTax + p.type23extraTax + p.type23roomsExtraTax + p.type24extraTax + p.type24roomsExtraTax
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: p.type21extraTax + p.type21roomsExtraTax + p.type22extraTax + p.type22roomsExtraTax + p.type23extraTax + p.type23roomsExtraTax + p.type24extraTax + p.type24roomsExtraTax
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                }
            },
            {
                name: "Прогноз по эффекту в первый год",
                field: (p) => {
                    let fullExtraTax = {
                        v: 0.3 * (0.7 * (p.type21extraTax + p.type21roomsExtraTax) + 0.5 * (p.type22extraTax + p.type22roomsExtraTax) + 0.3 * (p.type23extraTax + p.type23roomsExtraTax) + 0.1 * (p.type24extraTax + p.type24roomsExtraTax))
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[0];
                },
                unit: (p) => {
                    let fullExtraTax = {
                        v: 0.3 * (0.7 * (p.type21extraTax + p.type21roomsExtraTax) + 0.5 * (p.type22extraTax + p.type22roomsExtraTax) + 0.3 * (p.type23extraTax + p.type23roomsExtraTax) + 0.1 * (p.type24extraTax + p.type24roomsExtraTax))
                    }
                    return getRoundedMoneyValue(fullExtraTax, 'v', 0)[1];
                }
            },

            { //2.1
                name: "Целые ОКС на подходящих ЗУ по сведениям ЕГРН",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type21extraTax && p.type21extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type21extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type21extraCount} (в реестре уже было ${p.type21count - p.type21extraCount}), по ним налог ${(Number.parseFloat(p.type21extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#D10015'
                },
                needButton: true,
                originalId: "type21extraTax"
            },
            { //2.1
                name: "Помещения на подходящих ЗУ по сведениям ЕГРН",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type21roomsExtraTax && p.type21roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type21roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type21roomsCount}, по ним налог ${(Number.parseFloat(p.type21roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#D10015'
                },
                needButton: true,
                originalId: "type21roomsExtraTax"
            },

            { //2.2
                name: "Целые ОКС на подходящих ЗУ по иным сведениям",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type22extraTax && p.type22extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type22extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type22extraCount} (в реестре уже было ${p.type22count - p.type22extraCount}), по ним налог ${(Number.parseFloat(p.type22extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#FF6A00'
                },
                needButton: true,
                originalId: "type22extraTax"
            },
            { //2.2
                name: "Помещения на подходящих ЗУ по иным сведениям",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type22roomsExtraTax && p.type22roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type22roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type22roomsCount}, по ним налог ${(Number.parseFloat(p.type22roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#FF6A00'
                },
                needButton: true,
                originalId: "type22roomsExtraTax"
            },

            { //2.3
                name: "Целые ОКС, подходящие по признакам из ГКО",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type23extraTax && p.type23extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type23extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type23extraCount} (в реестре уже было ${p.type23count - p.type23extraCount}), по ним налог ${(Number.parseFloat(p.type23extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#F8D617'
                },
                needButton: true,
                originalId: "type23extraTax"
            },
            { //2.3
                name: "Помещения, подходящие по признакам из ГКО",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type23roomsExtraTax && p.type23roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type23roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type23roomsCount}, по ним налог ${(Number.parseFloat(p.type23roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: '#F8D617'
                },
                needButton: true,
                originalId: "type23roomsExtraTax"
            },

            { //2.4
                name: "Фактически используемые целые ОКС",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type24extraTax && p.type24extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type24extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type24extraCount} (в реестре уже было ${p.type24count - p.type24extraCount}), по ним налог ${(Number.parseFloat(p.type24extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#BFBC18"
                },
                needButton: true,
                originalId: "type24extraTax"
            },
            { //2.4
                name: "Фактически используемые помещения",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type24roomsExtraTax && p.type24roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type24roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type24roomsCount}, по ним налог ${(Number.parseFloat(p.type24roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#BFBC18"
                },
                needButton: true,
                originalId: "type24roomsExtraTax"
            },

            { //2.5
                name: "Не зарегистрированные ОКС",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type25extraTax && p.type25extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type25extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type25extraCount} (в реестре уже было ${p.type25count - p.type25extraCount}), по ним налог ${(Number.parseFloat(p.type25extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#508F89"
                },
                needButton: true,
                originalId: "type25extraTax"
            },
            { //2.5
                name: "Не зарегистрированные помещения",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type25roomsExtraTax && p.type25roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type25roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type25roomsCount}, по ним налог ${(Number.parseFloat(p.type25roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#508F89"
                },
                needButton: true,
                originalId: "type25roomsExtraTax"
            },

            { //2.6
                name: "ОКС, учтенные как жилые",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type26extraTax && p.type26extraTax !== 0
                        ? (
                            firstPart
                                ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type26extraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                                : `<span class=${classNames.main}>Новых ОКС ${p.type26extraCount} (в реестре уже было ${p.type26count - p.type26extraCount}), по ним налог ${(Number.parseFloat(p.type26extraTax) / 1000000).toFixed(3)} млн.руб/год<br/></span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#508F89"
                },
                needButton: true,
                originalId: "type26extraTax"
            },
            { //2.6
                name: "Помещения, учтенные как жилые",
                field: (p, isRegionLayer = false, classNames, firstPart = true) => {
                    return p.type26roomsExtraTax && p.type26roomsExtraTax !== 0
                        ? (firstPart
                            ? `<div style="display: flex">${Math.round(Number.parseFloat(p.type26roomsExtraTax) / 1000000)}<p class="${classNames.unit}" style="font-size: 16px">млн.руб/год</p></div>`
                            : `<span class=${classNames.main}>Новых помещений ${p.type26roomsCount}, по ним налог ${(Number.parseFloat(p.type26roomsExtraTax) / 1000000).toFixed(3)} млн.руб/год млн.руб/год</span>`
                        )
                        : ""
                },
                style: {
                    ...styleForProps,
                    maxWidth: "100%",
                    fontSize: "40px",
                    color: "#508F89"
                },
                needButton: true,
                originalId: "type26roomsExtraTax"
            },

            { //2.7
                name: "Лишние в региональном реестре",
                field: (p, isRegion) => isRegion && p.type27count !== 0 ? p.type27count : "",
                unit: "шт."
            },
            */


            {
                name: "Максимальный дополнительный налог",
                field: (p) => getRoundedMoneyValue(p, 'maxTaxEffect')[0],
                unit: (p) => getRoundedMoneyValue(p, 'maxTaxEffect')[1]
            },
            {
                name: "Вероятность включения в региональный перечень",
                field: (p) => (p.probability ? Math.round(100 * (p.probability || 0)) + '%' : null)
            },
            {
                name: 'Стоимость',
                field: (p) => getRoundedMoneyValue(p, 'Cost')[0],
                unit: (p) => getRoundedMoneyValue(p, 'Cost')[1]
            },
            {
                name: 'Источник',
                field: (p) => {
                    if (p.origin) {
                        const originNum = p.origin.split(".").at(-1)
                        if (originNum === "1") return "ОКС на подходящих ЗУ по сведениям ЕГРН"
                        if (originNum === "2") return "ОКС на подходящих ЗУ по иным сведениям"
                        if (originNum === "3") return "ОКС по признакам из ГКО"
                        if (originNum === "4") return "ОКС фактически используемые"
                        if (originNum === "5") return "Не зарегистрированные ОКС"
                        if (originNum === "6") return "ОКС, учтенные как жилые"
                        if (originNum === "7") return "Лишние в региональном реестре"
                        return p.origin
                    }
                    return ''
                },
                style: styleForProps
            },
            { name: 'Площадь', field: "Square", unit: "м²" },
            { name: 'Оценочная группа (код)', field: (p) => p.EvalCode ? p.EvalCode : '' },
            { name: 'Назначение', field: (p) => p.Purpose ? p.Purpose : '' },
            { name: 'Тип строения', field: (p) => p.buildingType ? p.buildingType : '', style: { fontSize: "22px" } },
            { name: 'Комм.организаций', field: "maxOrgsCount", unit: "шт." },
            {
                name: 'Макс.доп. налог',
                field: (p) => getRoundedMoneyValue(p, 'maxTaxEffect')[0],
                unit: (p) => getRoundedMoneyValue(p, 'maxTaxEffect')[1]
            },
            {
                name: 'Согласно источнику',
                field: (p) => {
                    if (p.geomSource) {
                        if (p.geomSource === 'oks') return 'Точная форма ОКС'
                        if (p.geomSource === 'lands') return 'Примерное положение по ЗУ'
                        if (p.geomSource === 'oap') return 'Примерное положение по ОАП'
                    }
                    return ""
                },
                style: {
                    fontSize: "22px"
                }
            },
            {
                name: 'ГКО',
                field: (p) => {
                    if (p.suspiciousByGKO) {
                        return p.suspiciousByGKO ? 'Похож на торгово-офисный' : 'Нет признаков'
                    }
                    return ""
                },
                style: {
                    fontSize: "22px"
                }
            },
            {
                name: 'В региональном реестре на 2025',
                field: (p) => {
                    if (p.containsInRegistry) {
                        return p.containsInRegistry ? 'Присутствует' : 'Отсутствует'
                    }
                    return ""
                },
                style: {
                    fontSize: "22px"
                }
            },
            {
                name: 'Земельный участок',
                field: (p) => {
                    if (p.lands && JSON.parse(p.lands).length > 1) {
                        const largestSquare = JSON.parse(p.lands).sort((a, b) => b.Square - a.Square)[0];
                        return `${largestSquare.ID ? `<b>Кад. номер: </b>` + largestSquare.ID : ''}${largestSquare.AddressDesc ? '<br/><b>Адрес:</b> ' + largestSquare.AddressDesc : ''}${largestSquare.Allowed ? '<br/><b>ВРИ:</b> ' + largestSquare.Allowed : ''}${largestSquare.AllowedDoc ? '<br/><b>ВРИ по документу:</b> ' + largestSquare.AllowedDoc : ''}${largestSquare.Square ? '<br/><b>Площадь:</b> ' + largestSquare.Square + "м2" : ''}${largestSquare.Cost ? '<br/><b>Стоимость:</b> ' + getRoundedMoneyValue(largestSquare, 'cost')[0] + getRoundedMoneyValue(largestSquare, 'cost')[1] : ''}${largestSquare.EvalGroup ? '<br/><b>Оценочная группа:</b> ' + largestSquare.EvalGroup : ''}${largestSquare.EvalSubgroup ? '<br/><b>Оценочная подгруппа:</b> ' + largestSquare.EvalSubgroup : ''}`
                    }
                    return ""
                },
                style: {
                    ...styleForProps,
                    fontSize: "16px",
                    fontWeight: 400
                }
            },
            {
                name: 'Все земельные участки',
                field: (p) => {
                    if (p.lands && JSON.parse(p.lands).length > 1) {
                        return JSON.parse(p.lands).map((data, index) => `${data.ID ? `${index !== 0 ? '<br/>' : ''}` + data.ID : ''}`);
                    }
                    return ""
                },
                style: {
                    ...styleForProps,
                    fontSize: "16px",
                    fontWeight: 400
                }
            },
        ],
        territoryNameFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return properties.ID ? properties.ID :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return properties.AddressDesc ? properties.AddressDesc :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }
    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.ID || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


